"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useRouter } from "@/i18n/navigation";
import { useT } from "@/lib/i18n";
import { useBetaPrefix } from "@/lib/api/prefix.client";
import { CHARACTERS, MODE_AXIS, PLAYER_AXIS, SKILL_AXIS, combineBracket, parseBracket } from "./bracket";
const API = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";
function pillCls(active: boolean): string {
  return `rounded-full border px-3 py-1 text-xs transition-colors ${active ? "border-[var(--accent-gold)] bg-[var(--accent-gold)]/15 text-[var(--accent-gold)]" : "border-[var(--border-subtle)] bg-[var(--bg-card)] text-[var(--text-secondary)] hover:border-[var(--text-muted)]"}`;
}
export default function BracketPicker(t0) {
  const $ = _c(29);
  const {
    basePath,
    bracket,
    character,
    showCharacter
  } = t0;
  const t = useT();
  const bp = useBetaPrefix();
  const router = useRouter();
  const sel = parseBracket(bracket);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [versions, setVersions] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      fetch(`${API}/api/runs/versions`).then(_temp).then(d => setVersions(d?.stat_versions || [])).catch(_temp2);
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== basePath || $[4] !== bp || $[5] !== router) {
    t4 = (key, char) => {
      const params = new URLSearchParams();
      params.set("bracket", key);
      if (char) {
        params.set("character", char);
      }
      const qs = params.toString();
      router.push(qs ? `${bp}${basePath}?${qs}` : `${bp}${basePath}`);
    };
    $[3] = basePath;
    $[4] = bp;
    $[5] = router;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const nav = t4;
  let t5;
  if ($[7] !== character || $[8] !== nav || $[9] !== t) {
    t5 = (label, options, current, pick) => <div className="mb-2 flex flex-wrap items-center gap-1.5"><span className="mr-1 w-14 text-xs text-[var(--text-muted)]">{t(label)}</span>{options.map(o => <button key={o.key || "all"} type="button" onClick={() => nav(pick(o.key), character)} className={pillCls(current === o.key)}>{t(o.label)}</button>)}</div>;
    $[7] = character;
    $[8] = nav;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const axis = t5;
  const t6 = "mb-3";
  const t7 = axis("Players", PLAYER_AXIS, sel.player, k => combineBracket(k, sel.skill, sel.mode, sel.version));
  const t8 = axis("Skill", SKILL_AXIS, sel.skill, k_0 => combineBracket(sel.player, k_0, sel.mode, sel.version));
  const t9 = axis("Mode", MODE_AXIS, sel.mode, k_1 => combineBracket(sel.player, sel.skill, k_1, sel.version));
  let t10;
  if ($[11] !== character || $[12] !== nav || $[13] !== sel || $[14] !== t || $[15] !== versions) {
    t10 = versions.length > 0 && <div className="mb-2 flex flex-wrap items-center gap-1.5"><span className="mr-1 w-14 text-xs text-[var(--text-muted)]">{t("Version")}</span><select aria-label={t("Version")} value={sel.version} onChange={e => nav(combineBracket(sel.player, sel.skill, sel.mode, e.target.value), character)} className="rounded-md border border-[var(--border-subtle)] bg-[var(--bg-card)] px-2 py-1 text-xs text-[var(--text-secondary)] focus:outline-none focus:border-[var(--accent-gold)]"><option value="">{t("All versions")}</option>{versions.map(_temp3)}</select></div>;
    $[11] = character;
    $[12] = nav;
    $[13] = sel;
    $[14] = t;
    $[15] = versions;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== bracket || $[18] !== character || $[19] !== nav || $[20] !== showCharacter || $[21] !== t) {
    t11 = showCharacter && <div className="mb-2 flex flex-wrap items-center gap-1.5"><span className="mr-1 w-14 text-xs text-[var(--text-muted)]">{t("Played by")}</span><button type="button" onClick={() => nav(bracket, "")} className={pillCls(character === "")}>{t("All")}</button>{CHARACTERS.map(c => <button key={c} type="button" onClick={() => nav(bracket, c)} className={pillCls(character === c)}>{t(c.charAt(0) + c.slice(1).toLowerCase())}</button>)}</div>;
    $[17] = bracket;
    $[18] = character;
    $[19] = nav;
    $[20] = showCharacter;
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t12 = <div className={t6}>{t7}{t8}{t9}{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp3(v) {
  return <option key={v} value={v}>{v}</option>;
}
function _temp2() {}
function _temp(r) {
  return r.ok ? r.json() : null;
}